import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faStop } from '@fortawesome/free-solid-svg-icons';
import MarkdownIt from 'markdown-it';

// Инициализация markdown парсера
const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: true,
  typographer: true
});

const StreamingMessage = ({ 
  streamingText, 
  isStreaming, 
  tokenCount = 0,
  onCancel, 
  className = '' 
}) => {
  const [displayText, setDisplayText] = useState('');
  const [showCursor, setShowCursor] = useState(true);

  // Эффект для обновления отображаемого текста
  useEffect(() => {
    setDisplayText(streamingText || '');
  }, [streamingText]);

  // Эффект для мигающего курсора
  useEffect(() => {
    if (!isStreaming) {
      setShowCursor(false);
      return;
    }

    setShowCursor(true);
    const interval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 530); // Немного медленнее для лучшей видимости

    return () => clearInterval(interval);
  }, [isStreaming]);

  // Обработка разметки markdown для потокового текста
  const renderStreamingText = (text) => {
    if (!text) return '';
    
    // Простая обработка markdown на лету
    return text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      .replace(/`(.*?)`/g, '<code>$1</code>')
      .replace(/\n/g, '<br>');
  };

  const formatTokenInfo = () => {
    if (!tokenCount) return '';
    
    // Примерная оценка времени и скорости
    const avgWordsPerToken = 0.75;
    const words = Math.round(tokenCount * avgWordsPerToken);
    
    return `${tokenCount} токенов, ~${words} слов`;
  };

  return (
    <div className={`message assistant streaming ${className}`}>
      <div className="message-content">
        {/* Убираем заголовок для более минималистичного вида */}
        
        <div className="message-text">
          <div 
            className="streaming-text"
            style={{ color: 'var(--assistant-text-color)' }}
            dangerouslySetInnerHTML={{
              __html: renderStreamingText(displayText) + (showCursor && isStreaming ? '<span class="cursor-blink">|</span>' : '')
            }}
          />
        </div>
        
        {isStreaming && (
          <div className="streaming-status mt-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="streaming-info small" style={{ color: 'var(--assistant-text-color)', opacity: 0.7 }}>
                <div className="d-flex align-items-center">
                  <div className="thinking-animation me-2">
                    <div className="thinking-container">
                      <span className="thinking-dot"></span>
                      <span className="thinking-dot"></span>
                      <span className="thinking-dot"></span>
                    </div>
                  </div>
                  <span>
                    Генерируется...
                    {tokenCount > 0 && (
                      <span className="ms-2">({formatTokenInfo()})</span>
                    )}
                  </span>
                </div>
              </div>
              

            </div>
          </div>
        )}
        
        {!isStreaming && tokenCount > 0 && (
          <div className="completion-info small mt-2" style={{ color: 'var(--assistant-text-color)', opacity: 0.6 }}>
            <span className="text-success me-1">✓</span>
            Завершено: {formatTokenInfo()}
          </div>
        )}
      </div>
    </div>
  );
};

export default StreamingMessage; 